export default {
  'pages.userCenter.breadcrumb.home': '首页',
  'pages.userCenter.name': '会员中心',
  'pages.userCenter.oc.name': '我的订单',
  'pages.userCenter.oc.order': '订单列表',
  'pages.userCenter.oc.intention': '意向单列表',
  'pages.userCenter.cc.name': '关注中心',
  'pages.userCenter.cc.collect': '我的关注',
  'pages.userCenter.ac.name': '账户设置',
  'pages.userCenter.ac.account.name': '账户信息',
  'pages.userCenter.ac.security.name': '安全中心',
  'pages.userCenter.notification.name': '通知中心',
  'pages.userCenter.notification.platform.name': '平台通知',
  'pages.userCenter.notification.filter.7days': '近7天',
  'pages.userCenter.notification.filter.30days': '近30天',
  'pages.userCenter.notification.filter.all': '全部',
  'pages.userCenter.notification.download': '下载',
  'pages.userCenter.notification.more': '查看详情',
  'pages.userCenter.collection.name': '关注商品',
  'pages.userCenter.collection.time.label': '关注时间',
  'pages.userCenter.collection.goods.detail': '查看详情',
  'pages.userCenter.collection.goods.cancelCollect': '取消关注',
};
